import script from "./head.vue?vue&type=script&setup=true&lang=ts"
export * from "./head.vue?vue&type=script&setup=true&lang=ts"

import "./head.vue?vue&type=style&index=0&id=429a97d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-429a97d6"]])

export default __exports__